import { Component, Inject, OnInit } from '@angular/core'
import { Store } from '@ngrx/store'
import { FormBuilder, FormGroup } from '@angular/forms'
import { SaveForm } from '@tokeet-frontend/tv3-platform'
import { ContractTemplate, UpdateContractTemplate } from '@tokeet-frontend/signature'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

@Component({
  selector: 'app-rename-template-dialog',
  templateUrl: './rename-template-dialog.component.html',
  styleUrls: ['./rename-template-dialog.component.scss'],
  host: { class: 'modal-content' },
})
export class RenameTemplateDialogComponent implements OnInit {
  form = this.fb.group({
    name: [],
  })

  constructor(
    private dialogRef: MatDialogRef<RenameTemplateDialogComponent>,
    private fb: FormBuilder,
    private store: Store<any>,
    @Inject(MAT_DIALOG_DATA) public data: { template: ContractTemplate }
  ) {}

  ngOnInit() {
    this.form.patchValue({ name: this.data.template.name })
  }

  close() {
    this.dialogRef.close()
  }

  @SaveForm()
  onSave(form: FormGroup) {
    const { name } = this.form.getRawValue()

    this.store.dispatch(
      UpdateContractTemplate({
        id: this.data.template.id,
        payload: { name },
        message: $localize`Template renamed successfully.`,
      })
    )
    this.close()
  }
}
